import { Navigate, RouteObject } from "react-router-dom";
import ProjectList from "./list";
import ProjectDetail from './detail';
import ProjectNew from "./new";
import MilestoneList from "./milestoneList"
import { PpmLayout } from "../layouts";
import Board from "./board"
import OverBudget from "./overBudget"
import MilestonePlan from "./milestonePlan/index"
import MilestonePlanList from "./milestonePlanList/index"

// const Board = lazy(() => import("./board/index"))

const projectsRoute: RouteObject = {
  path: 'projects',
  element: <PpmLayout />,
  children: [
    {
      index: true,
      element: (<ProjectList />),
    },
    {
      path: 'overBudget',
      element: (<OverBudget />),
    },
    {
      path: ':projectID/board',
      element: (<Board />),
    },
    {
      path: 'new',
      element: (<ProjectNew />),
    }, {
      path: 'milestones',
      element: (<MilestoneList />),
    },
    {
      path: ':projectID',
      element: (<Navigate to="dashboard" />),
    },
    {
      path: ':projectID/:tab',
      element: (<ProjectDetail />)
    },
    {
      path: ':projectID/milestone-plan',
      element: (<MilestonePlan />),
    },
    {
      path: 'milestone-plan-list',
      element: (<MilestonePlanList />),
    },
  ],
};

export default projectsRoute;
